"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyParagraph = void 0;
const react_1 = __importDefault(require("react"));
const tags_1 = require("./tags");
const EmptyParagraph = () => {
    return (react_1.default.createElement(tags_1.w.p, null,
        react_1.default.createElement(tags_1.w.pPr, null,
            react_1.default.createElement(tags_1.w.pStyle, { "w:val": "EmptyParagraph" }))));
};
exports.EmptyParagraph = EmptyParagraph;
exports.default = exports.EmptyParagraph;
//# sourceMappingURL=EmptyParagraph.js.map